import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { useToast } from "@circle-react-uikit/ToastV2";
import { Modal } from "./Modal";
import { i18nRoot } from "./constants";
import { useMediaSettings } from "./hooks/useMediaSettings";
import { useUpdateMediaSettings } from "./hooks/useUpdateMediaSettings";
import type { ModalTab } from "./types";

interface MediaSettingsModalProps {
  initialTab?: ModalTab;
  onChaptersUpdated?: (mediaSettings: MediaSetting) => void;
  signedId: string;
}

const MediaSettingsModalComponent = ({
  signedId,
  initialTab,
  onChaptersUpdated,
}: MediaSettingsModalProps) => {
  const modal = useModal();
  const toast = useToast();

  const { data: mediaSettings } = useMediaSettings({ signedId });
  const {
    mutateAsync: updateMediaSettings,
    isLoading: isUpdatingMediaSettings,
  } = useUpdateMediaSettings({
    signedId,
    onSuccess: () => toast.success(t(`${i18nRoot}.update.success`)),
    onError: () => toast.error(t(`${i18nRoot}.update.error`)),
  });

  return (
    <Modal
      isOpen={modal.visible}
      isSubmitting={isUpdatingMediaSettings}
      mediaSettings={mediaSettings}
      onSubmit={updateMediaSettings}
      onClose={modal.hide}
      initialTab={initialTab}
      onChaptersUpdated={onChaptersUpdated}
    />
  );
};

const MediaSettingsModal = ModalManager.create(
  (props: MediaSettingsModalProps) => (
    <MediaSettingsModalComponent {...props} />
  ),
);

export const useMediaSettingsModal = () => useModal(MediaSettingsModal);
